module.exports = __webpack_public_path__ + "static/media/notification.b67ead29.mp3";